// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badges-row {
  display: inline-flex;
  align-items: center;
}

.badge-item {
  display: inline-grid;
  place-items: center;
  border: none;
  background: transparent;
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0,0,0,0.4);
  transition: transform 160ms ease, box-shadow 160ms ease;
}
.badge-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.badge-item:hover {
  transform: translateY(-4px) scale(1.04);
  box-shadow: 0 10px 30px rgba(99,102,241,0.24);
}
.badge-item.badge-super {
  box-shadow: 0 8px 28px rgba(124,58,237,0.28), 0 0 18px rgba(56,189,248,0.08) inset;
  border-radius: 12px;
}
.badges-section {
  display: flex;
  gap: 10px;
  align-items: center;
}
.badges-section.empty { color: rgba(255,255,255,0.35); font-size: 13px; }
.badges-section.normal .badge-item { width: 40px; height: 40px; }
.badges-section.kiosk .badge-item { width: 56px; height: 56px; }
.badge-item { display: inline-flex; align-items: center; justify-content: center; cursor: default; }
.badge-ring { width: 100%; height: 100%; border-radius: 999px; padding: 4px; box-shadow: 0 0 10px rgba(56, 189, 248, 0.06), inset 0 1px 0 rgba(255,255,255,0.03); background: linear-gradient(180deg, rgba(255,255,255,0.03), rgba(0,0,0,0.08)); transition: transform 0.18s ease, box-shadow 0.18s ease; }
.badge-item img { width: 100%; height: 100%; object-fit: cover; border-radius: 999px; display: block; }
.badge-item:hover .badge-ring { transform: translateY(-4px); box-shadow: 0 6px 24px rgba(56, 189, 248, 0.18); }
.badges-section.kiosk .badge-ring { box-shadow: 0 0 18px rgba(59,130,246,0.12); }
.badges-section .badge-item:active .badge-ring { transform: translateY(-2px) scale(.98); }

/* Profile modal badge row (larger, centered, SC2 + Solana neon) */
.profile-badge-row {
  margin-top: 12px;
  margin-bottom: 22px;
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
}

.profile-badge-icon {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  object-fit: contain;
  filter: drop-shadow(0 0 12px rgba(0, 255, 255, 0.85)) drop-shadow(0 0 20px rgba(120, 0, 255, 0.65));
  transition: transform 0.18s ease, filter 0.18s ease;
}
.profile-badge-icon:hover {
  transform: scale(1.08);
  filter: drop-shadow(0 0 16px rgba(0, 255, 255, 1)) drop-shadow(0 0 26px rgba(120, 0, 255, 0.8));
}

/* Kiosk-specific badge row (larger icons for tablet) */
.kiosk-badge-row {
  margin-top: 12px;
  margin-bottom: 28px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.kiosk-badge-icon {
  width: 80px;
  height: 80px;
  filter: drop-shadow(0 0 14px rgba(0, 255, 255, 0.85)) drop-shadow(0 0 24px rgba(120, 0, 255, 0.7));
  border-radius: 10px;
  object-fit: contain;
}

/* Header adjustments */
.profile-header h2,
.kiosk-student-header h2 {
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  text-shadow: 0 0 14px rgba(0, 255, 255, 0.65);
}
.belt-tag {
  display: block;
  text-align: center;
  font-size: 16px;
  color: #b4b4b4;
  margin-top: 4px;
}

/* Mobile responsiveness */
@media (max-width: 480px) {
  .profile-badge-icon { width: 60px; height: 60px; }
  .kiosk-badge-icon { width: 70px; height: 70px; }
  .profile-badge-row, .kiosk-badge-row { gap: 8px; }
}

/* SC2-style badge pulse */
@keyframes badgePulse {
  0%   { filter: drop-shadow(0 0 10px rgba(0,255,255,0.6)); }
  50%  { filter: drop-shadow(0 0 16px rgba(0,255,255,0.95)); }
  100% { filter: drop-shadow(0 0 10px rgba(0,255,255,0.6)); }
}

.profile-badge-icon,
.kiosk-badge-icon {
  animation: badgePulse 2.5s infinite ease-in-out;
}

/* Portal specific badge icon (StudentPortal larger visibility) */
.portal-badge-icon {
  width: 70px !important;
  height: 70px !important;
  object-fit: contain;
  filter: drop-shadow(0 0 10px rgba(0,255,255,0.9));
  margin: 6px;
}

.portal-badge-wrapper {
  width: 100%;
  margin-top: 12px;
}

.portal-section-title {
  font-size: 14px;
  color: #dbeafe;
  margin: 0 0 8px 0;
  font-weight: 700;
}

.portal-badge-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
  min-height: 70px; /* IMPORTANT: prevents collapsing */
  overflow-x: auto;
  scrollbar-width: thin;
  padding-bottom: 6px;
  position: relative;
  z-index: 10;
}

.portal-badge-row::-webkit-scrollbar { height: 6px; }

/* Intro animation (large -> normal with glow fade) */
@keyframes badgeIntro {
  0% {
    transform: scale(1.3);
    filter: drop-shadow(0 0 20px rgba(0,255,255,1));
    opacity: 0;
  }
  60% {
    transform: scale(1.05);
    filter: drop-shadow(0 0 14px rgba(0,255,255,0.9));
    opacity: 1;
  }
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 8px rgba(0,255,255,0.7));
  }
}

.portal-badge-animated {
  animation: badgeIntro 0.8s ease-out;
}
.kiosk-badge-animated {
  animation: badgeIntroKiosk 0.8s ease-out;
  transform-origin: center center;
}
.profile-badge-animated {
  animation: badgeIntro 0.8s ease-out;
}

@keyframes badgeIntroKiosk {
  0% {
    transform: scale(1.4);
    filter: drop-shadow(0 0 28px rgba(0,255,255,1));
    opacity: 0;
  }
  60% {
    transform: scale(1.08);
    filter: drop-shadow(0 0 18px rgba(0,255,255,0.95));
    opacity: 1;
  }
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 10px rgba(0,255,255,0.75));
  }
}

/* Badges tab grid */
.badges-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 20px;
  padding: 20px;
}

.badge-card {
  background: #0c1018;
  border-radius: 12px;
  padding: 12px;
  text-align: center;
  box-shadow: 0 0 14px rgba(0,255,255,0.2);
  transition: transform 0.2s ease;
}
.badge-card:hover { transform: scale(1.08); box-shadow: 0 0 20px rgba(0,255,255,0.4); }
.badge-card img { width: 80px; height: 80px; object-fit: contain; filter: drop-shadow(0 0 10px rgba(0,255,255,0.8)); }
.badge-card-title { color: #d8d8d8; margin-top: 8px; text-shadow: 0 0 8px rgba(0,255,255,0.6); font-size: 14px; }

/* Progress bar for logic badges */
.badge-progress {
  margin-top: 8px;
  height: 8px;
  background: rgba(255,255,255,0.06);
  border-radius: 6px;
  overflow: hidden;
}
.badge-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #00fff7, #00ff88);
  transition: width 0.3s ease;
}
.badge-progress-text {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 6px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/BadgesSection.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,uDAAuD;AACzD;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,uCAAuC;EACvC,6CAA6C;AAC/C;AACA;EACE,kFAAkF;EAClF,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA,wBAAwB,6BAA6B,EAAE,eAAe,EAAE;AACxE,qCAAqC,WAAW,EAAE,YAAY,EAAE;AAChE,oCAAoC,WAAW,EAAE,YAAY,EAAE;AAC/D,cAAc,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE;AACnG,cAAc,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE,YAAY,EAAE,mFAAmF,EAAE,6EAA6E,EAAE,uDAAuD,EAAE;AAC1S,kBAAkB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,cAAc,EAAE;AACtG,gCAAgC,2BAA2B,EAAE,+CAA+C,EAAE;AAC9G,oCAAoC,0CAA0C,EAAE;AAChF,iDAAiD,sCAAsC,EAAE;;AAEzF,kEAAkE;AAClE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mGAAmG;EACnG,mDAAmD;AACrD;AACA;EACE,sBAAsB;EACtB,+FAA+F;AACjG;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kGAAkG;EAClG,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB,WAAW,EAAE,YAAY,EAAE;EACjD,oBAAoB,WAAW,EAAE,YAAY,EAAE;EAC/C,uCAAuC,QAAQ,EAAE;AACnD;;AAEA,0BAA0B;AAC1B;EACE,OAAO,iDAAiD,EAAE;EAC1D,OAAO,kDAAkD,EAAE;EAC3D,OAAO,iDAAiD,EAAE;AAC5D;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA,iEAAiE;AACjE;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB,EAAE,mCAAmC;EACrD,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA,uCAAuC,WAAW,EAAE;;AAEpD,qDAAqD;AACrD;EACE;IACE,qBAAqB;IACrB,+CAA+C;IAC/C,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,iDAAiD;IACjD,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,gDAAgD;EAClD;AACF;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,qBAAqB;IACrB,+CAA+C;IAC/C,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,kDAAkD;IAClD,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,kDAAkD;EACpD;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,+BAA+B;AACjC;AACA,oBAAoB,sBAAsB,EAAE,wCAAwC,EAAE;AACtF,kBAAkB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,iDAAiD,EAAE;AACrH,oBAAoB,cAAc,EAAE,eAAe,EAAE,wCAAwC,EAAE,eAAe,EAAE;;AAEhH,kCAAkC;AAClC;EACE,eAAe;EACf,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".badges-row {\n  display: inline-flex;\n  align-items: center;\n}\n\n.badge-item {\n  display: inline-grid;\n  place-items: center;\n  border: none;\n  background: transparent;\n  padding: 0;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.4);\n  transition: transform 160ms ease, box-shadow 160ms ease;\n}\n.badge-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.badge-item:hover {\n  transform: translateY(-4px) scale(1.04);\n  box-shadow: 0 10px 30px rgba(99,102,241,0.24);\n}\n.badge-item.badge-super {\n  box-shadow: 0 8px 28px rgba(124,58,237,0.28), 0 0 18px rgba(56,189,248,0.08) inset;\n  border-radius: 12px;\n}\n.badges-section {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.badges-section.empty { color: rgba(255,255,255,0.35); font-size: 13px; }\n.badges-section.normal .badge-item { width: 40px; height: 40px; }\n.badges-section.kiosk .badge-item { width: 56px; height: 56px; }\n.badge-item { display: inline-flex; align-items: center; justify-content: center; cursor: default; }\n.badge-ring { width: 100%; height: 100%; border-radius: 999px; padding: 4px; box-shadow: 0 0 10px rgba(56, 189, 248, 0.06), inset 0 1px 0 rgba(255,255,255,0.03); background: linear-gradient(180deg, rgba(255,255,255,0.03), rgba(0,0,0,0.08)); transition: transform 0.18s ease, box-shadow 0.18s ease; }\n.badge-item img { width: 100%; height: 100%; object-fit: cover; border-radius: 999px; display: block; }\n.badge-item:hover .badge-ring { transform: translateY(-4px); box-shadow: 0 6px 24px rgba(56, 189, 248, 0.18); }\n.badges-section.kiosk .badge-ring { box-shadow: 0 0 18px rgba(59,130,246,0.12); }\n.badges-section .badge-item:active .badge-ring { transform: translateY(-2px) scale(.98); }\n\n/* Profile modal badge row (larger, centered, SC2 + Solana neon) */\n.profile-badge-row {\n  margin-top: 12px;\n  margin-bottom: 22px;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.profile-badge-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 8px;\n  object-fit: contain;\n  filter: drop-shadow(0 0 12px rgba(0, 255, 255, 0.85)) drop-shadow(0 0 20px rgba(120, 0, 255, 0.65));\n  transition: transform 0.18s ease, filter 0.18s ease;\n}\n.profile-badge-icon:hover {\n  transform: scale(1.08);\n  filter: drop-shadow(0 0 16px rgba(0, 255, 255, 1)) drop-shadow(0 0 26px rgba(120, 0, 255, 0.8));\n}\n\n/* Kiosk-specific badge row (larger icons for tablet) */\n.kiosk-badge-row {\n  margin-top: 12px;\n  margin-bottom: 28px;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  width: 100%;\n}\n\n.kiosk-badge-icon {\n  width: 80px;\n  height: 80px;\n  filter: drop-shadow(0 0 14px rgba(0, 255, 255, 0.85)) drop-shadow(0 0 24px rgba(120, 0, 255, 0.7));\n  border-radius: 10px;\n  object-fit: contain;\n}\n\n/* Header adjustments */\n.profile-header h2,\n.kiosk-student-header h2 {\n  text-align: center;\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n  text-shadow: 0 0 14px rgba(0, 255, 255, 0.65);\n}\n.belt-tag {\n  display: block;\n  text-align: center;\n  font-size: 16px;\n  color: #b4b4b4;\n  margin-top: 4px;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 480px) {\n  .profile-badge-icon { width: 60px; height: 60px; }\n  .kiosk-badge-icon { width: 70px; height: 70px; }\n  .profile-badge-row, .kiosk-badge-row { gap: 8px; }\n}\n\n/* SC2-style badge pulse */\n@keyframes badgePulse {\n  0%   { filter: drop-shadow(0 0 10px rgba(0,255,255,0.6)); }\n  50%  { filter: drop-shadow(0 0 16px rgba(0,255,255,0.95)); }\n  100% { filter: drop-shadow(0 0 10px rgba(0,255,255,0.6)); }\n}\n\n.profile-badge-icon,\n.kiosk-badge-icon {\n  animation: badgePulse 2.5s infinite ease-in-out;\n}\n\n/* Portal specific badge icon (StudentPortal larger visibility) */\n.portal-badge-icon {\n  width: 70px !important;\n  height: 70px !important;\n  object-fit: contain;\n  filter: drop-shadow(0 0 10px rgba(0,255,255,0.9));\n  margin: 6px;\n}\n\n.portal-badge-wrapper {\n  width: 100%;\n  margin-top: 12px;\n}\n\n.portal-section-title {\n  font-size: 14px;\n  color: #dbeafe;\n  margin: 0 0 8px 0;\n  font-weight: 700;\n}\n\n.portal-badge-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 70px; /* IMPORTANT: prevents collapsing */\n  overflow-x: auto;\n  scrollbar-width: thin;\n  padding-bottom: 6px;\n  position: relative;\n  z-index: 10;\n}\n\n.portal-badge-row::-webkit-scrollbar { height: 6px; }\n\n/* Intro animation (large -> normal with glow fade) */\n@keyframes badgeIntro {\n  0% {\n    transform: scale(1.3);\n    filter: drop-shadow(0 0 20px rgba(0,255,255,1));\n    opacity: 0;\n  }\n  60% {\n    transform: scale(1.05);\n    filter: drop-shadow(0 0 14px rgba(0,255,255,0.9));\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    filter: drop-shadow(0 0 8px rgba(0,255,255,0.7));\n  }\n}\n\n.portal-badge-animated {\n  animation: badgeIntro 0.8s ease-out;\n}\n.kiosk-badge-animated {\n  animation: badgeIntroKiosk 0.8s ease-out;\n  transform-origin: center center;\n}\n.profile-badge-animated {\n  animation: badgeIntro 0.8s ease-out;\n}\n\n@keyframes badgeIntroKiosk {\n  0% {\n    transform: scale(1.4);\n    filter: drop-shadow(0 0 28px rgba(0,255,255,1));\n    opacity: 0;\n  }\n  60% {\n    transform: scale(1.08);\n    filter: drop-shadow(0 0 18px rgba(0,255,255,0.95));\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    filter: drop-shadow(0 0 10px rgba(0,255,255,0.75));\n  }\n}\n\n/* Badges tab grid */\n.badges-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));\n  gap: 20px;\n  padding: 20px;\n}\n\n.badge-card {\n  background: #0c1018;\n  border-radius: 12px;\n  padding: 12px;\n  text-align: center;\n  box-shadow: 0 0 14px rgba(0,255,255,0.2);\n  transition: transform 0.2s ease;\n}\n.badge-card:hover { transform: scale(1.08); box-shadow: 0 0 20px rgba(0,255,255,0.4); }\n.badge-card img { width: 80px; height: 80px; object-fit: contain; filter: drop-shadow(0 0 10px rgba(0,255,255,0.8)); }\n.badge-card-title { color: #d8d8d8; margin-top: 8px; text-shadow: 0 0 8px rgba(0,255,255,0.6); font-size: 14px; }\n\n/* Progress bar for logic badges */\n.badge-progress {\n  margin-top: 8px;\n  height: 8px;\n  background: rgba(255,255,255,0.06);\n  border-radius: 6px;\n  overflow: hidden;\n}\n.badge-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #00fff7, #00ff88);\n  transition: width 0.3s ease;\n}\n.badge-progress-text {\n  font-size: 11px;\n  color: #94a3b8;\n  margin-top: 6px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
